import { useState, useEffect } from "react";
import PropTypes from 'prop-types';

const FONT = "'Inter', -apple-system, BlinkMacSystemFont, sans-serif";
const KEY  = "exiq_cookie_consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  function accept() {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed", bottom: 0, left: 0, right: 0,
      background: "#0F2230", borderTop: "1px solid #142D3E",
      padding: "14px 24px", display: "flex", alignItems: "center",
      justifyContent: "space-between", flexWrap: "wrap", gap: 12,
      zIndex: 9999, fontFamily: FONT, boxShadow: "0 -4px 24px rgba(0,0,0,0.3)",
    }}>
      <div style={{ fontSize: 13, color: "#B5B9BC", maxWidth: 680, lineHeight: 1.5 }}>
        We use functional cookies to keep you signed in and remember your preferences.
        No advertising or tracking cookies.{" "}
        <a href="/privacy" style={{ color: "#22D3EE", textDecoration: "none" }}>Privacy Policy</a>
      </div>
      <button onClick={accept} style={{
        background: "#22D3EE", border: "none", borderRadius: 6,
        padding: "8px 20px", fontSize: 13, fontWeight: 700,
        color: "#0A1720", cursor: "pointer", fontFamily: FONT, flexShrink: 0,
      }}>
        Got it
      </button>
    </div>
  );
}
